/**
* LoginFormMdule is a reusable Module to use the login module features
*/

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Own Components
import { DateFieldComponent } from './date-field.component';
import { CalendarModule } from '../calendar/calendar.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CalendarModule,
    ],
    declarations: [
        DateFieldComponent
    ],
    exports: [
        DateFieldComponent
    ]
})
export class DateFieldModule {}
